module.exports = __webpack_public_path__ + "img/american-express@2x.e65b2c0e.png";